import { render, staticRenderFns } from "./PlatformSchemeModal.vue?vue&type=template&id=531280a2&"
import script from "./PlatformSchemeModal.vue?vue&type=script&lang=js&"
export * from "./PlatformSchemeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports